import React, { ChangeEventHandler, FC } from "react";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import RatesDownIcon from "components/icons/RatesDownIcon";

interface RatesSelectProps {
  value: string;
  label: string;
  onChange: (value: string) => void;
  options: Array<{ value: string, label: string }>;
  placeholder: string;
}

const RatesSelect: FC<RatesSelectProps> = (props) => {
  const { value, placeholder, label, onChange, options } = props;
  const theme = useTheme();
  const styles = createStyles(theme);

  const handleChange: ChangeEventHandler<HTMLSelectElement> = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={styles.root}>
      <label className={styles.label}>{label}</label>
      <RatesDownIcon />
      <select
        className={styles.select}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        disabled={options.length === 0}
      >
        {options.map((option) => (
          <option value={option.value} key={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  );
};

const createStyles = (theme: Theme) => (
  {
    root: css`
      position: relative;
      border-color: #d3d5dc;
      border-style: solid;
      border-width: 1px;
      background-color: #fff;
      border-radius: 6px;
      padding: 6px 0;

      > * {
        font-family: Mulish, sans-serif;
      }

      svg {
        pointer-events: none;
        position: absolute;
        top: calc(50% + 5px);
        right: 16px;
        cursor: pointer;
      }
    `,
    label: css`
      width: 100%;
      color: #909090;
      font-size: 14px;
      font-weight: 500;
      line-height: 19px;
      padding: 0 16px;
    `,
    select: css`
      border: none;
      color: #000;
      width: 100%;
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;
      letter-spacing: 0.5px;
      padding: 0 16px;
      appearance: none;
      cursor: pointer;
    `
  }
);

export default RatesSelect;